import { EntityConstants } from '../../helpers/general.helper';

export const paramsConstants: EntityConstants = {
	apiEndpoint: '/api/params',
	entityLabel: 'Parámetro',
	entityLabelGender: 'M',
	navigateToParent: '/med/params'
}

export interface Param {
	id: string;
	value: string;
}